const fieldClass = 'w-full min-h-11 bg-slate-900 rounded-lg border border-white/20 p-2 text-sm text-white';
const fields = {
  experiences: [['company', 'Entreprise'], ['client', 'Client'], ['role', 'Poste'], ['start_date', 'Début'], ['end_date', 'Fin'], ['summary', 'Résumé'], ['responsibilities', 'Responsabilités'], ['achievements', 'Réalisations'], ['technical_environment', 'Environnement technique'], ['functional_environment', 'Environnement métier']],
  missions: [['name', 'Mission'], ['client', 'Client'], ['role', 'Poste'], ['start_date', 'Début'], ['end_date', 'Fin'], ['context', 'Contexte'], ['responsibilities', 'Responsabilités'], ['technical_environment', 'Environnement technique'], ['environment', 'Outils']],
  projects: [['name', 'Projet'], ['description', 'Description'], ['technologies', 'Technologies']],
  education: [['title', 'Diplôme'], ['institution', 'Établissement'], ['year', 'Année'], ['details', 'Détails']],
  certifications: [['name', 'Certification'], ['issuer', 'Organisme'], ['year', 'Année']],
  languages: [['name', 'Langue'], ['level', 'Niveau']]
};
const titles = {
  experiences: 'Expériences',
  missions: 'Missions',
  projects: 'Projets',
  education: 'Formations',
  certifications: 'Certifications',
  languages: 'Langues'
};
function Records({
  kind,
  items,
  onChange
}) {
  return <div className="space-y-3">{items.map((item, i) => <fieldset key={i} className="border border-white/15 rounded-lg p-3 space-y-3">
    <legend className="px-1 text-sm text-slate-200">{titles[kind]} {i + 1}</legend>
    {typeof item === 'string' ? <label className="block text-sm text-slate-300">Intitulé<input className={fieldClass} value={item} onChange={e => onChange(items.map((v, n) => n === i ? e.target.value : v))} /></label> : <>
      <div className="grid gap-3 sm:grid-cols-2">{fields[kind].map(([key, label]) => <label key={key} className="block text-sm text-slate-300">{label}
        <textarea aria-label={label} rows={Array.isArray(item[key]) ? 3 : 1} className={fieldClass} value={Array.isArray(item[key]) ? item[key].join('\n') : item[key] || ''} onChange={e => onChange(items.map((v, n) => n === i ? {
              ...v,
              [key]: Array.isArray(item[key]) ? e.target.value.split('\n').filter(Boolean) : e.target.value
            } : v))} />
      </label>)}</div>
      {(item.missions || []).length > 0 && <Records kind="missions" items={item.missions} onChange={missions => onChange(items.map((v, n) => n === i ? {
          ...v,
          missions
        } : v))} />}
      {(item.sections || []).map((section, n) => <label key={n} className="block text-sm text-slate-300">{section.title || 'Détails de la mission'}<textarea className={fieldClass} value={section.items?.length ? section.items.join('\n') : section.content || ''} onChange={e => onChange(items.map((v, j) => j === i ? {
            ...v,
            sections: v.sections.map((s, k) => k === n ? {
              ...s,
              ...(s.items?.length ? {
                items: e.target.value.split('\n')
              } : {
                content: e.target.value
              })
            } : s)
          } : v))} /></label>)}
    </>}
  </fieldset>)}</div>;
}
export default function CandidateProfileReview({
  profile,
  onChange
}) {
  return <details className="border border-white/15 rounded-xl p-4 space-y-4">
    <summary className="cursor-pointer min-h-11 text-sm font-semibold text-slate-200">Vérifier les expériences, formations et certifications</summary>
    {['experiences', 'projects', 'education', 'certifications', 'languages'].map(kind => profile[kind]?.length > 0 && <Records key={kind} kind={kind} items={profile[kind]} onChange={items => onChange({
      ...profile,
      [kind]: items
    })} />)}
  </details>;
}
